import React from 'react';
import { Section, Container } from '../common';

const faqItems = [
  {
    question: 'Como o Léo Delivery me ajuda a economizar?',
    answer: 'Ao automatizar seus pedidos pelo WhatsApp e site próprio, você deixa de pagar as altas taxas dos marketplaces (que podem chegar a 30%) e reduz erros operacionais que geram desperdício de comida e tempo.'
  },
  {
    question: 'Preciso instalar algum programa no meu computador?',
    answer: 'Não! O Léo Delivery é 100% online. Você pode acessar de qualquer navegador, tablet ou celular. Seus dados ficam salvos na nuvem com total segurança.'
  },
  {
    question: 'O sistema funciona para quem está começando?',
    answer: 'Sim! Temos um plano gratuito ideal para quem está iniciando e quer profissionalizar o atendimento sem custos fixos iniciais.'
  },
  {
    question: 'Como funciona a integração com o WhatsApp?',
    answer: 'Seu cliente clica no link do seu cardápio, escolhe os produtos e, ao finalizar, o pedido chega pronto e organizado no seu WhatsApp ou painel de gestão, pronto para ir para a cozinha.'
  },
  {
    question: 'Posso aceitar pagamentos online?',
    answer: 'Sim, você pode configurar pagamentos via Pix (automático) e Cartões diretamente pelo cardápio, garantindo mais agilidade e segurança para você e seu cliente.'
  }
];

const FAQ = () => {
  return (
    <Section id="faq" className="bg-light py-5 py-lg-6">
      <Container>
        <div className="text-center mb-5" data-aos="fade-up">
          <h2 className="fw-bold display-5">Dúvidas Frequentes</h2>
          <p className="text-secondary lead">Tudo o que você precisa saber para começar</p>
        </div>
        
        <div className="row justify-content-center" data-aos="fade-up" data-aos-delay="200">
          <div className="col-lg-8">
            <div className="accordion accordion-flush accordion-custom shadow-sm rounded-4 overflow-hidden" id="faqAccordion">
              {faqItems.map((item, index) => (
                <div className="accordion-item border-bottom" key={index}>
                  <h2 className="accordion-header" id={`heading${index}`}>
                    <button 
                      className="accordion-button collapsed py-4 px-4 fw-bold text-dark fs-5" 
                      type="button" 
                      data-bs-toggle="collapse" 
                      data-bs-target={`#collapse${index}`} 
                      aria-expanded="false" 
                      aria-controls={`collapse${index}`}
                    >
                      {item.question}
                    </button>
                  </h2>
                  <div 
                    id={`collapse${index}`} 
                    className="accordion-collapse collapse" 
                    aria-labelledby={`heading${index}`} 
                    data-bs-parent="#faqAccordion"
                  >
                    <div className="accordion-body py-4 px-4 text-secondary fs-6 bg-white">
                      {item.answer}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        
        <div className="text-center mt-5">
          <p className="text-secondary mb-3">Ainda tem dúvidas?</p>
          <a href="https://wa.me/5545991439499" target="_blank" rel="noopener noreferrer" className="btn btn-primary-custom rounded-pill px-5 fw-bold shadow-sm">
            Falar com suporte agora
          </a>
        </div>
      </Container>
    </Section>
  );
};

export default FAQ;
